
import { createClient } from '@supabase/supabase-js';

// Configurația Supabase pentru LexSmart AI
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://barlksnnhwyjajptoqql.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJhcmxrc25uaHd5amFqcHRvcXFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk0MzQ5OTAsImV4cCI6MjA4NTAxMDk5MH0.PJJT0nnK5JPqzeKR4GEQNkwtMZHQzEZYH6Pyb7L-nbA';

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
export const supabase = createClient(SUPABASE_URL ?? '', SUPABASE_ANON_KEY ?? '');

/**
 * Verifică sănătatea conexiunii cu baza de date.
 */
export const checkSupabaseHealth = async () => {
  try {
    if (!isSupabaseConfigured) return false;
    const { error } = await supabase.from('profiles').select('id', { count: 'exact', head: true }).limit(1);
    return !error;
  } catch (err) {
    console.warn("Supabase Health Check Failed:", err);
    return false;
  }
};
